import axios from 'axios';
import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost, postFile, postMigrationFile } from './axiosUtils';
import './axiosInterceptor';

const AttachmentService = {
  async downloadProfileImage(userId: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost('/attachment/downloadProfile', { loginId: userId });
  },
  async downloadBeforeAfter(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost('/attachment/downloadFile', payload);
  },
  async downloadOther(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axios.post('/attachment/downloadOtherFile', payload, {
      responseType: 'blob',
    });
  },

  async downloadSelected(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axios.post('/attachment/downloadSelectedFile', payload, {
      responseType: 'blob',
    });
  },

  async postUploadBeforeAfter(formData: FormData): AxiosUtilsType {
    return await postFile(`attachment/uploadFile`, formData);
  },
  async postUploadProfile(formData: FormData): AxiosUtilsType {
    return await postFile(`attachment/uploadProfile`, formData);
  },
  async removeProfile(loginId: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`attachment/removeProfile`, loginId);
  },
  async uploadBulkUpdateFile(name: string, formData: FormData, campaignId: string): AxiosUtilsType {
    return await postMigrationFile(`bulk-upload/inventory?name=${name}&campaignId=${campaignId}`, formData);
  },
};
export default AttachmentService;
